export const globalListeners = {
  initial: 'idle',
  invoke: {
    src: 'watchRouteChange',
  },
  states: {
    idle: {
      on: {
        UPDATE_PAGE: {
          target: 'waitForRouteChange',
          actions: [
            'updatePrevPageArray',
            'updateCurrentPagePath',
            'updateUrl',
            'layout_changePageId',
          ],
        },
        VIEW_HEADER_MENU_ITEM_CLICK: {
          target: 'handlingNavigationItem',
          actions: ['handleSubnavigationScrollReset', 'trackMenuItemClick'],
        },
        VIEW_SIDE_MENU_ITEM_CLICK: [
          {
            target: 'handlingNavigationItem',
            cond: 'isClickedItemInternal',
            actions: 'trackSideItemClick',
          },
          {
            actions: 'trackSideItemClick',
          },
        ],
        VIEW_SIDE_MENU_GAME_INFO_CLICK: {
          actions: [
            {
              type: 'save',
              data: {
                changePageAction: 'INFO',
              },
            },
            'trackSideItemClick',
          ],
          target: 'handlingGameDetails',
        },
        VIEW_SIDE_MENU_COMMAND_CLICK: [
          {
            target: 'openingAccountItemModal',
            cond: 'isClickedItemAccount',
            actions: 'trackMainMenuItemClick',
          },
          {
            actions: 'trackMainMenuItemClick',
          },
        ],
        VIEW_CATEGORY_VIEW_ALL_CLICK: {
          actions: [
            {
              type: 'save',
              data: {
                changePageAction: 'VIEW_ALL',
              },
            },
          ],
          target: 'handlingNavigationItem',
        },
        VIEW_FLOATING_ICON_CLICK: {
          target: 'handlingNavigationItem',
          actions: 'trackFloatingIcon',
        },
        VIEW_CATEGORY_ROUTE_ITEM_CLICK: {
          target: 'handlingNavigationItem',
          actions: 'trackPromoClick',
        },
        VIEW_CATEGORY_LINK_ITEM_CLICK: {
          actions: 'trackPromoClick',
        },
        VIEW_BOTTOM_MENU_ITEM_CLICK: [
          {
            target: 'handlingNavigationItem',
            cond: 'isClickedItemInternal',
            actions: ['trackBottomNavigationClick', 'scrollTop'],
          },
          {
            actions: 'trackBottomNavigationClick',
          },
        ],
        VIEW_BOTTOM_MENU_COMMAND_CLICK: [
          {
            target: 'executingBottomMenuCommand',
            actions: ['trackBottomNavigationClick'],
          },
        ],
        VIEW_ERROR_ITEM_CLICK: [
          {
            target: 'handlingErrorItem',
            actions: [
              {
                type: 'save',
                data: { isErrorPage: false, initialRequest: true },
              },
              'trackErrorItemClick',
            ],
            cond: 'isClickedItemInternal',
          },
          {
            actions: [
              { type: 'save', data: { initialRequest: true } },
              'trackErrorItemClick',
            ],
          },
        ],
        VIEW_MAIN_MENU_ITEM_CLICK: [
          {
            target: 'handlingNavigationItem',
            actions: ['trackMainMenuItemClick', 'scrollTop'],
            cond: 'isClickedItemInternal',
          },
          {
            target: 'openingAccountItemModal',
            cond: 'isClickedItemAccount',
            actions: 'trackMainMenuItemClick',
          },
          {
            actions: 'trackMainMenuItemClick',
          },
        ],
        VIEW_MAIN_MENU_CLOSE_CLICK: 'closeMainMenu',
        VIEW_HEADER_BACK_BUTTON_CLICK: 'handlingBackButtonClick',
        VIEW_BREADCRUMB_CLICK: 'handlingNavigationItem',
        VIEW_CATEGORY_GAME_TILE_INFO_CLICK: {
          actions: [
            {
              type: 'save',
              data: {
                changePageAction: 'INFO',
              },
            },
          ],
          target: 'handlingGameDetails',
        },
        OPEN_GAME_DETAILS: 'handlingGameDetails',
        VIEW_SEARCH_WRAPPER_CLICK: 'handlingNavigationItem',
        OPEN_GAME_MODAL: {
          target: 'waitForRouteChange',
          actions: [
            'updatePrevPageArray',
            'updateCurrentPagePath',
            'updateUrl',
            'saveScrollPosition',
            'layout_openGameModal',
            'disableZoom',
          ],
        },
        DEPOSIT_MODAL_STATE_OPENED: {
          actions: 'scrollTopAndSetBodyNonScrollable',
        },
        DEPOSIT_MODAL_STATE_CLOSED: {
          actions: 'setBodyScrollable',
        },
        VIEW_CLOSE_GAME_MODAL_TRIGGER: 'chooseGameModalCloseMethod',
        VIEW_CLOSE_GAME_MODAL_THROUGH_GAME_FRAME: {
          target: 'closeGameModalThroughGameFrame',
          actions: ['enableZoom'],
        },
        VIEW_CLOSE_GAME_MODAL: {
          target: 'closeGameModal',
          actions: ['enableZoom'],
        },
        VIEW_VIDEO_MODAL_CLOSE_CLICK: 'closeVideoModal',
        VIEW_OPEN_DEPOSIT_GAME_MODAL: {
          actions: ['openDeposit', 'trackDepositClick'],
        },
        VIEW_SIDEBAR_OVERLAY_CLICK: 'closeSidebar',
        VIEW_SEARCH_MODAL_CLOSE: 'closeSearchModal',
        VIEW_SEARCH_MODAL_CLOSE_TRIGGER: 'closeSearchModalTrigger',
        VIEW_MODAL_OVERLAY_CLICK: 'closeModal',
        VIEW_STEP_ITEM_CLICK: {
          actions: 'trackStepItemClick',
        },
        VIEW_VIDEO_ITEM_CLICK: 'handlingVideoItem',
        VIEW_BANNER_STANDALONE_ITEM_CLICK: {
          actions: 'trackBannerStandaloneItemClick',
        },
        VIEW_CATEGORY_SHUFFLE_CLICK: {
          actions: ['fetchShuffleGames', 'trackShuffleGamesClick'],
        },
        VIEW_SEARCH_DESKTOP_OVERLAY_CLICK: {
          actions: 'goBack',
        },
        UPDATE_PROMOTIONS_URL: 'updatePromotionsUrl',
        SESSION_STATE_LOGGED_OUT: {
          target: 'goingBackToPreviousPage',
          cond: 'currentlyOnRecentlyPlayedPage',
        },
        NAV_HANDLE_CHANGE: [
          {
            target: 'handlingLeftSliderCommand',
            cond: 'isLeftSliderCommand',
          },
          {
            target: 'handlingNavigationItem',
          },
        ],
        ROUTE_CHANGED: 'reactOnRouteChange',
        GLOBAL_GOBACK: 'goingBackToPreviousPage',
      },
    },
    executingBottomMenuCommand: {
      invoke: {
        src: 'executeBottomMenuCommand',
        onDone: {
          target: 'idle',
        },
      },
    },
    openingAccountItemModal: {
      invoke: {
        src: 'fetchAccountItemModal',
        onDone: {
          target: 'idle',
        },
      },
    },
    waitForRouteChange: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'idle',
          cond: 'isRoutingNotEnabled',
        },
        VIEW_CLOSE_GAME_MODAL: 'closeGameModal',
        VIEW_VIDEO_MODAL_CLOSE: 'closeVideoModal',
        LAYOUT_SIDEBAR_CLOSE: {
          target: 'idle',
          cond: 'isRoutingNotEnabled',
        },
        LAYOUT_MODAL_CLOSE: {
          target: 'idle',
          cond: 'isRoutingNotEnabled',
        },
        ROUTE_CHANGED: 'idle',
      },
    },
    updatePromotionsUrl: {
      entry: 'updatePromotionsPath',
      always: 'waitForRouteChange',
    },
    closeSidebar: {
      invoke: {
        src: 'fetchPreviousPageInfo',
        onDone: {
          target: 'waitForRouteChange',
          actions: [
            {
              type: 'save',
              data: {
                previousPageArray: '$event.data.previousPageArray',
                seo: {
                  page: '$context.seo.page',
                  sidebar: null,
                },
              },
              meta: {
                selectors: [
                  '$action.data.previousPageArray',
                  '$action.data.seo.page',
                ],
              },
            },
            'updateUrl',
            'updateCurrentPagePath',
            'layout_closeSidebar',
            'setBodyScrollable',
          ],
        },
      },
    },
    closeSearchModalTrigger: {
      entry: 'layout_closeSearchModalTrigger',
      always: 'idle',
    },
    closeSearchModal: {
      invoke: {
        src: 'fetchPreviousPageInfo',
        onDone: {
          target: 'waitForRouteChange',
          actions: [
            {
              type: 'save',
              data: {
                previousPageArray: '$event.data.previousPageArray',
                seo: {
                  page: '$context.seo.page',
                  modal: null,
                },
              },
              meta: {
                selectors: [
                  '$action.data.previousPageArray',
                  '$action.data.seo.page',
                ],
              },
            },
            'updateUrl',
            'updateCurrentPagePath',
            'layout_closeSearchModal',
            'setBodyScrollable',
          ],
        },
      },
    },
    closeModal: {
      invoke: {
        src: 'fetchPreviousPageInfo',
        onDone: {
          target: 'waitForRouteChange',
          actions: [
            {
              type: 'save',
              data: {
                previousPageArray: '$event.data.previousPageArray',
                seo: {
                  page: '$context.seo.page',
                  modal: null,
                },
              },
              meta: {
                selectors: [
                  '$action.data.previousPageArray',
                  '$action.data.seo.page',
                ],
              },
            },
            'updateUrl',
            'updateCurrentPagePath',
            'layout_closeModal',
            'setBodyScrollable',
          ],
        },
      },
    },
    openDeposit: {
      entry: 'openDeposit',
      always: 'idle',
    },
    chooseGameModalCloseMethod: {
      entry: 'chooseGameModalCloseMethod',
      always: 'idle',
    },
    closeGameModalThroughGameFrame: {
      entry: 'sendGameModalCloseToGameFrame',
      always: 'idle',
    },
    closeGameModal: {
      invoke: {
        src: 'fetchPreviousPageInfo',
        onDone: {
          actions: [
            {
              type: 'save',
              data: {
                previousPageArray: '$event.data.previousPageArray',
                trackingData: {
                  page: '$context.trackingData.page',
                  modal: null,
                },
                seo: {
                  page: '$context.seo.page',
                  modal: null,
                },
              },
              meta: {
                selectors: [
                  '$action.data.previousPageArray',
                  '$action.data.trackingData.page',
                  '$action.data.seo.page',
                ],
              },
            },
            'setBodyScrollable',
            'setFullScreenOff',
            'layout_closeGameModal',
            'removeGameLaunchController',
            'showBalance',
            'updateBalance',
            'updateCurrentPagePath',
            'updateUrl',
            'layout_changePageId',
          ],
          target: 'waitForRouteChange',
        },
      },
    },
    closeVideoModal: {
      invoke: {
        src: 'fetchPreviousPageInfo',
        onDone: {
          target: 'waitForRouteChange',
          actions: [
            {
              type: 'save',
              data: {
                previousPageArray: '$event.data.previousPageArray',
                trackingData: {
                  page: '$context.trackingData.page',
                  sidebar: null,
                  modal: null,
                },
                isVideoEnabled: false,
                seo: {
                  page: '$context.seo.page',
                  sidebar: null,
                  modal: null,
                },
              },
              meta: {
                selectors: [
                  '$action.data.previousPageArray',
                  '$action.data.trackingData.page',
                  '$action.data.seo.page',
                ],
              },
            },
            'setBodyScrollable',
            'updateCurrentPagePath',
            'layout_closeVideoModal',
            'updateUrl',
          ],
        },
      },
    },
    closeMainMenu: {
      entry: [
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Menu.properties.visible',
                value: false,
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path:
                  'components.BottomNavigation.properties.activeCommandItem',
                value: false,
              },
            },
          ],
        },
      ],
      always: 'idle',
    },
    reactOnRouteChange: {
      invoke: {
        src: 'fetchPageInfo',
        onDone: [
          {
            actions: [
              'setBodyScrollable',
              'scrollTop',
              'updateCurrentPagePath',
              'showBalance',
              'layout_closeGameModal',
              'layout_changePageId',
            ],
            target: 'idle',
          },
        ],
      },
    },
    handlingVideoItem: {
      entry: [
        'layout_exitChange',
        'resetPageAction',
        'updatePrevPageArray',
        'updateCurrentPagePath',
        'saveScrollPosition',
        'updateUrl',
        'layout_changePageId',
      ],
      always: 'waitForRouteChange',
    },
    handlingGameDetails: {
      entry: [
        'layout_exitChange',
        'resetPageAction',
        'updatePrevPageArray',
        'updateCurrentPagePath',
        'updateUrl',
        'layout_changePageId',
      ],
      always: 'waitForRouteChange',
    },
    handlingErrorItem: {
      entry: [
        'updatePrevPageArray',
        'updateCurrentPagePath',
        'resetPageAction',
        'updateUrl',
        'layout_changePageId',
      ],
      always: 'waitForRouteChange',
    },
    handlingNavigationItem: {
      entry: [
        'layout_exitChange',
        'updatePrevPageArray',
        'updateCurrentPagePath',
        'resetPageAction',
        'saveScrollPosition',
        'updateUrl',
        'layout_changePageId',
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Menu.properties.visible',
                value: false,
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Navigation.properties.initialScrollValue',
                value: '$context.subnavigationScrollPosition',
              },

              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path:
                  'components.BottomNavigation.properties.activeCommandItem',
                value: false,
              },
            },
          ],
        },
      ],
      always: 'waitForRouteChange',
    },
    handlingLeftSliderCommand: {
      entry: [
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Menu.properties.visible',
                value: true,
              },
            },
          ],
        },
      ],
      always: 'idle',
    },
    handlingBackButtonClick: {
      always: 'closingApp',
    },
    goingBackToPreviousPage: {
      invoke: {
        src: 'fetchPreviousPageInfo',
        onDone: {
          actions: [
            {
              type: 'save',
              data: {
                changePageAction: 'BACK',
                previousPageArray: '$event.data.previousPageArray',
              },
              meta: {
                selectors: ['$action.data.previousPageArray'],
              },
            },
            'setBodyScrollable',
            'updateCurrentPagePath',
            'setScrollRestore',
            'updateUrl',
            'layout_changePageId',
          ],
          target: 'waitForRouteChange',
        },
      },
    },
    closingApp: {
      entry: ['scrollTop', 'closeApplication'],
      always: 'idle',
    },
  },
};
